// German UI catalog — generated from the English strings used in the JSX (English text is the key).
// Regenerate the key list with scripts/i18n-keys.mjs; keep entries in English order.
export const de: Record<string, string> = {
  "+ Add": "+ Hinzufügen",
  "+ Task": "+ Aufgabe",
  "+ sub": "+ Unter",
  "1 person notified": "1 Person benachrichtigt",
  "1 private project hidden": "1 privates Projekt ausgeblendet",
  "1 private project is hidden from these totals.": "1 privates Projekt ist in diesen Summen nicht enthalten.",
  "1 project": "1 Projekt",
  "1 year": "1 Jahr",
  "1. Scan the code with your authenticator app, or enter this key manually:": "1. Scanne den Code mit deiner Authenticator-App oder gib diesen Schlüssel manuell ein:",
  "13 weeks": "13 Wochen",
  "2. Enter the 6-digit code the app shows to confirm.": "2. Gib zur Bestätigung den 6-stelligen Code ein, den die App anzeigt.",
  "26 weeks": "26 Wochen",
  "30 days": "30 Tage",
  "4 weeks": "4 Wochen",
  "8 weeks": "8 Wochen",
  "90 days": "90 Tage",
  "A flag is a named on/off switch you control here without a deploy. Every signed-in browser receives the current flags, and features can check them to show or hide something.": "Ein Flag ist ein benannter Ein/Aus-Schalter, den du hier ohne Deployment steuerst. Jeder angemeldete Browser erhält die aktuellen Flags, und Funktionen können sie prüfen, um etwas ein- oder auszublenden.",
  "A person is": "Eine Person ist",
  "A portfolio groups related projects under one initiative (a client, a programme, a department) with a shared board, list and Gantt.": "Ein Portfolio fasst zusammengehörige Projekte unter einer Initiative (ein Kunde, ein Programm, eine Abteilung) mit gemeinsamem Board, Liste und Gantt zusammen.",
  "A portfolio groups related projects under one initiative (a client, a programme, a department).": "Ein Portfolio bündelt zusammengehörige Projekte unter einer Initiative (ein Kunde, ein Programm, eine Abteilung).",
  "A private project appears only in your own project list — no one else can see it, whatever their role": "Ein privates Projekt erscheint nur in deiner eigenen Projektliste — niemand sonst kann es sehen, unabhängig von der Rolle",
  "A simple sub-task with its own key; it appears here, not on the board": "Eine einfache Unteraufgabe mit eigenem Schlüssel; sie erscheint hier, nicht auf dem Board",
  "A token acts as this person through the API: projects, portfolios, tasks, schedules and their time, never rates, payroll or admin. Everything it does is audited as them, marked with the token's name, and your name is recorded as the one who issued it.": "Ein Token handelt über die API im Namen dieser Person: Projekte, Portfolios, Aufgaben, Zeitpläne und ihre Zeit, nie Sätze, Lohn oder Admin. Alles, was es tut, wird als diese Person protokolliert, mit dem Namen des Tokens, und dein Name wird als Aussteller festgehalten.",
  "A token lets Claude Code (or a script) act as you through the API: projects, portfolios, tasks, schedules, links, milestones and your time. It never reaches rates, budgets, payroll, approvals, admin or account settings, whatever your role.": "Ein Token lässt Claude Code (oder ein Skript) über die API in deinem Namen handeln: Projekte, Portfolios, Aufgaben, Zeitpläne, Verknüpfungen, Meilensteine und deine Zeit. Sätze, Budgets, Lohn, Genehmigungen, Admin oder Kontoeinstellungen erreicht es nie, unabhängig von deiner Rolle.",
  "API tokens": "API-Tokens",
  "Account": "Konto",
  "Accounts are invite-only. If you have an invite link, open it to set up your account.": "Konten gibt es nur auf Einladung. Wenn du einen Einladungslink hast, öffne ihn, um dein Konto einzurichten.",
  "Action": "Aktion",
  "Actions": "Aktionen",
  "Active only": "Nur aktive",
  "Add": "Hinzufügen",
  "Add a comment": "Kommentar hinzufügen",
  "Add a milestone on this day": "Meilenstein an diesem Tag hinzufügen",
  "Add a person": "Person hinzufügen",
  "Add a person…": "Person hinzufügen…",
  "Add a status column (columns are the project's statuses)": "Statusspalte hinzufügen (Spalten sind die Status des Projekts)",
  "Add a subtask under this task": "Unteraufgabe unter dieser Aufgabe hinzufügen",
  "Add a task due on this day": "Aufgabe mit Fälligkeit an diesem Tag hinzufügen",
  "Add a task in this column": "Aufgabe in dieser Spalte hinzufügen",
  "Add a top-level task": "Aufgabe auf oberster Ebene hinzufügen",
  "Add checklist item": "Checklistenpunkt hinzufügen",
  "Add column": "Spalte hinzufügen",
  "Add entry": "Eintrag hinzufügen",
  "Add holiday": "Feiertag hinzufügen",
  "Add project…": "Projekt hinzufügen…",
  "Add rate": "Satz hinzufügen",
  "Add subtask": "Unteraufgabe hinzufügen",
  "Add task": "Aufgabe hinzufügen",
  "Add the column at the end; drag its header to reorder": "Fügt die Spalte am Ende an; Kopfzeile ziehen zum Umsortieren",
  "Add the item": "Punkt hinzufügen",
  "Added": "Hinzugefügt",
  "Address / CIDR": "Adresse / CIDR",
  "Addresses on file (restriction currently off):": "Hinterlegte Adressen (Einschränkung derzeit aus):",
  "Adds a second step to password sign-in: a 6-digit code from an app such as Google Authenticator, 1Password or Authy.": "Fügt der Passwort-Anmeldung einen zweiten Schritt hinzu: ein 6-stelliger Code aus einer App wie Google Authenticator, 1Password oder Authy.",
  "Admin console": "Admin-Konsole",
  "After": "Nach",
  "Alert at %": "Warnung bei %",
  "All portfolios you can see; create one there": "Alle Portfolios, die du sehen kannst; dort eines anlegen",
  "All projects": "Alle Projekte",
  "All states": "Alle Zustände",
  "Amount": "Betrag",
  "An account for an integration, left out of payroll, timesheets and scheduled reports": "Ein Konto für eine Integration: bleibt außerhalb von Lohn, Stundenzetteln und geplanten Berichten",
  "An invite lets them pick their own password. Creating an account here sends no email at all: it exists straight away, and you decide whether it has a password.": "Eine Einladung lässt sie ihr Passwort selbst wählen. Ein Konto hier zu erstellen verschickt keine E-Mail: es existiert sofort, und du entscheidest, ob es ein Passwort hat.",
  "Analytics": "Analysen",
  "Any action": "Beliebige Aktion",
  "Any milestone": "Beliebiger Meilenstein",
  "Any priority": "Beliebige Priorität",
  "Any project": "Beliebiges Projekt",
  "Any status": "Beliebiger Status",
  "Anyone": "Jeder",
  "Approvals": "Freigaben",
  "Approve although it was not submitted — you'll be warned if the week is empty or thin, and the person is notified": "Trotz fehlender Einreichung freigeben — du wirst gewarnt, wenn die Woche leer oder dünn ist, und die Person wird benachrichtigt",
  "Approve without submission?": "Ohne Einreichung freigeben?",
  "Approve — locks the week; any later work must be a correction entry": "Freigeben — sperrt die Woche; spätere Arbeit muss als Korrektureintrag erfasst werden",
  "Approve — reduces their available capacity for those days": "Freigeben — verringert die verfügbare Kapazität an diesen Tagen",
  "Approved": "Freigegeben",
  "Archive": "Archivieren",
  "Archive this portfolio? Its projects are unchanged; the portfolio drops out of the default lists.": "Dieses Portfolio archivieren? Seine Projekte bleiben unverändert; das Portfolio verschwindet aus den Standardlisten.",
  "Assign to…": "Zuweisen an…",
  "Assignee": "Zuständig",
  "At a glance": "Auf einen Blick",
  "At least 12 characters. A password found in a public breach is refused.": "Mindestens 12 Zeichen. Ein Passwort aus einem öffentlichen Datenleck wird abgelehnt.",
  "At least 12 characters. A short sentence works well.": "Mindestens 12 Zeichen. Ein kurzer Satz eignet sich gut.",
  "Attach files": "Dateien anhängen",
  "Attach files to the comment; you can also paste or drop them into it": "Dateien an den Kommentar anhängen; du kannst sie auch einfügen oder hineinziehen",
  "Attach files to this task; you can also drop them here": "Dateien an diese Aufgabe anhängen; du kannst sie auch hierher ziehen",
  "Attachments": "Anhänge",
  "Auto-schedule": "Automatische Planung",
  "Avatar URL": "Avatar-URL",
  "Awaiting approval": "Wartet auf Freigabe",
  "Awaiting your approval": "Wartet auf deine Freigabe",
  "Back": "Zurück",
  "Back to portfolios": "Zurück zu Portfolios",
  "Back to projects": "Zurück zu Projekten",
  "Baseline": "Baseline",
  "Before": "Vor",
  "Bill rates": "Abrechnungssätze",
  "Billable + non": "Abrechenbar + nicht",
  "Billable only": "Nur abrechenbar",
  "Billable value": "Abrechenbarer Wert",
  "Breadcrumb": "Brotkrumen",
  "Bulk-load people, projects, and an opening task backlog from CSV files.": "Personen, Projekte und ein anfängliches Aufgaben-Backlog aus CSV-Dateien massenhaft laden.",
  "Burndown / burnup": "Burndown / Burnup",
  "Calendar": "Kalender",
  "Calendar settings": "Kalendereinstellungen",
  "Cancel": "Abbrechen",
  "Cancel this pending invite": "Diese ausstehende Einladung stornieren",
  "Cancel this request (or approved leave that hasn't started)": "Diesen Antrag stornieren (oder genehmigte Abwesenheit, die noch nicht begonnen hat)",
  "Capacity": "Kapazität",
  "Category": "Kategorie",
  "Change any field on this person's record, including their email": "Jedes Feld im Datensatz dieser Person ändern, auch die E-Mail",
  "Change password": "Passwort ändern",
  "Change the email for {name} to {email}? That address is where password resets go, and they are told about the change.": "Die E-Mail von {name} auf {email} ändern? An diese Adresse gehen Passwort-Zurücksetzungen, und die Person wird über die Änderung informiert.",
  "Changes save as you edit; this confirms and closes the editor": "Änderungen werden beim Bearbeiten gespeichert; dies bestätigt und schließt den Editor",
  "Checking invite…": "Einladung wird geprüft…",
  "Checking…": "Wird geprüft…",
  "Choose the timezone carefully — it cannot be changed afterwards.": "Wähle die Zeitzone sorgfältig — sie kann später nicht geändert werden.",
  "Clear": "Zurücksetzen",
  "Click": "Klicken",
  "Click the": "Klicke auf",
  "Close": "Schließen",
  "Collapse": "Einklappen",
  "Collapse this card": "Diese Karte einklappen",
  "Collapse this section (remembered for you)": "Diesen Abschnitt einklappen (wird für dich gemerkt)",
  "Colour": "Farbe",
  "Delete {name}?": "{name} löschen?",
  "Download": "Herunterladen",
  "No files yet. Drop files here or use Attach files.": "Noch keine Dateien. Zieh Dateien hierher oder nutze „Dateien anhängen“.",
  "No files.": "Keine Dateien.",
  "Owner": "Verantwortlich",
  "Colour the task bars by owner (assignee). Remembered.": "Die Aufgabenbalken nach Verantwortlichem (zugewiesener Person) einfärben. Wird gemerkt.",
  "Colour for this calendar's events": "Farbe für die Termine dieses Kalenders",
  "Column (status) name shown on the board": "Spaltenname (Status), der auf dem Board angezeigt wird",
  "Column name": "Spaltenname",
  "Command": "Befehl",
  "Command palette": "Befehlspalette",
  "Comment": "Kommentar",
  "Comment deleted": "Kommentar gelöscht",
  "Comment deleted by {name}": "Kommentar von {name} gelöscht",
  "Comments": "Kommentare",
  "Commit": "Übernehmen",
  "Company holidays": "Betriebsfeiertage",
  "Completed": "Abgeschlossen",
  "Confirm new password": "Neues Passwort bestätigen",
  "Confirm password": "Passwort bestätigen",
  "Connect Google Calendar": "Google Kalender verbinden",
  "Connecting failed. Try again.": "Verbindung fehlgeschlagen. Bitte erneut versuchen.",
  "Continue with Google": "Mit Google fortfahren",
  "Copied": "Kopiert",
  "Copy all": "Alles kopieren",
  "Copy link": "Link kopieren",
  "Copy password": "Passwort kopieren",
  "Copy the claude mcp add command": "Den Befehl claude mcp add kopieren",
  "Copy the export line": "Die export-Zeile kopieren",
  "Copy the password so you can pass it on": "Das Passwort kopieren, um es weiterzugeben",
  "Copy the token": "Das Token kopieren",
  "Correct…": "Korrigieren…",
  "Cost rate": "Kostensatz",
  "Cost rates": "Kostensätze",
  "Could not create portfolio": "Portfolio konnte nicht angelegt werden",
  "Could not load the overview.": "Die Übersicht konnte nicht geladen werden.",
  "Create a one-time invite link (7 days) and email it if mail is configured": "Einmaligen Einladungslink (7 Tage) erstellen und per E-Mail senden, wenn Mail konfiguriert ist",
  "Create a project — you'll choose its permanent timezone-of-truth": "Projekt anlegen — du wählst seine dauerhafte Referenz-Zeitzone",
  "Create a task scheduled today for one week; drag its bar to adjust": "Aufgabe ab heute für eine Woche anlegen; Balken ziehen zum Anpassen",
  "Create a top-level task in this project; open it afterwards to set dates, assignee, estimate": "Aufgabe auf oberster Ebene in diesem Projekt anlegen; danach öffnen, um Termine, Zuständige und Schätzung zu setzen",
  "Create account": "Konto erstellen",
  "Create feed link": "Feed-Link erstellen",
  "Create invite": "Einladung erstellen",
  "Create one below, then file projects under it from a project's": "Lege unten eines an und ordne Projekte dann in den",
  "Create one from the Portfolios page, then file projects under it from a project's": "Lege eines auf der Seite Portfolios an und ordne ihm dann Projekte zu, jeweils auf der Projektseite unter",
  "Create project": "Projekt anlegen",
  "Create the account now — nobody is emailed": "Das Konto jetzt erstellen — es wird keine E-Mail verschickt",
  "Create the task": "Aufgabe anlegen",
  "Create the task in this column": "Aufgabe in dieser Spalte anlegen",
  "Create token": "Token erstellen",
  "Create your personal feed link": "Deinen persönlichen Feed-Link erstellen",
  "Created": "Erstellt",
  "Cumulative flow": "Kumulativer Fluss",
  "Cumulative flow, cycle time, burndown, velocity, forecast": "Kumulativer Fluss, Zykluszeit, Burndown, Velocity, Prognose",
  "Currency": "Währung",
  "Current password": "Aktuelles Passwort",
  "Cycle (d)": "Zyklus (T)",
  "Dashboard, projects, members, settings": "Dashboard, Projekte, Mitglieder, Einstellungen",
  "Dashboard, tasks, members, milestones, settings": "Dashboard, Aufgaben, Mitglieder, Meilensteine, Einstellungen",
  "Date": "Datum",
  "Dates": "Termine",
  "Dates in": "Termine in",
  "Day": "Tag",
  "Deactivate your account (history is kept); you will be asked to confirm": "Konto deaktivieren (Verlauf bleibt erhalten); du wirst um Bestätigung gebeten",
  "Decides whether this account can sign in the moment you create it": "Legt fest, ob sich dieses Konto sofort nach dem Erstellen anmelden kann",
  "Decline with a reason; the person is notified": "Mit Begründung ablehnen; die Person wird benachrichtigt",
  "Delete": "Löschen",
  "Delete column": "Spalte löschen",
  "Delete milestone": "Meilenstein löschen",
  "Delete task": "Aufgabe löschen",
  "Delete this column (only when empty)": "Diese Spalte löschen (nur wenn leer)",
  "Delete this comment? Its replies stay.": "Diesen Kommentar löschen? Die Antworten darauf bleiben erhalten.",
  "Delete this milestone": "Diesen Meilenstein löschen",
  "Delete this task": "Diese Aufgabe löschen",
  "Delete this task (and its subtasks); logged time is kept": "Diese Aufgabe (und ihre Unteraufgaben) löschen; erfasste Zeit bleibt erhalten",
  "Remove this file": "Diese Datei entfernen",
  "Resize the task list": "Größe der Aufgabenliste ändern",
  "Drag to resize the task list; double-click to reset": "Ziehen, um die Breite der Aufgabenliste zu ändern; Doppelklick setzt sie zurück",
  "Delete this task and its subtasks; logged time is kept": "Diese Aufgabe und ihre Unteraufgaben löschen; erfasste Zeit bleibt erhalten",
  "Description": "Beschreibung",
  "Directory": "Verzeichnis",
  "Discard": "Verwerfen",
  "Discuss this milestone": "Diesen Meilenstein besprechen",
  "Discussion": "Diskussion",
  "Dismiss": "Schließen",
  "Display only — never changes which week an entry belongs to.": "Nur zur Anzeige — ändert nie, zu welcher Woche ein Eintrag gehört.",
  "Does not match.": "Stimmt nicht überein.",
  "Done": "Erledigt",
  "Download CSV": "CSV herunterladen",
  "Download a JSON file with everything stored about you": "JSON-Datei mit allem herunterladen, was über dich gespeichert ist",
  "Download as a PDF table": "Als PDF-Tabelle herunterladen",
  "Download as an Excel workbook": "Als Excel-Arbeitsmappe herunterladen",
  "Download everything stored about you — profile, memberships, time entries, tasks assigned, leave, approvals, notifications — as JSON.": "Lade alles herunter, was über dich gespeichert ist — Profil, Mitgliedschaften, Zeiteinträge, zugewiesene Aufgaben, Abwesenheiten, Freigaben, Benachrichtigungen — als JSON.",
  "Download my data": "Meine Daten herunterladen",
  "Download partial CSV": "Teil-CSV herunterladen",
  "Download these rows as CSV": "Diese Zeilen als CSV herunterladen",
  "Drag cards, or focus a card and press": "Karten ziehen oder eine Karte fokussieren und drücken",
  "Drag to change priority; Space + arrows works from the keyboard": "Ziehen, um die Priorität zu ändern; Leertaste + Pfeile funktioniert per Tastatur",
  "Drag to move between columns or reorder; Space + arrows works from the keyboard": "Ziehen, um zwischen Spalten zu verschieben oder umzusortieren; Leertaste + Pfeile funktioniert per Tastatur",
  "Drop idle time — save up to the idle moment, then restart": "Leerlaufzeit verwerfen — bis zum Leerlaufmoment speichern, dann neu starten",
  "Due": "Fällig",
  "Each status maps to a global category (to do / in progress / done / archived) so reporting works across projects. Keep at least one per category. Archived work is left out of every count and hidden unless asked for.": "Jeder Status ist einer globalen Kategorie zugeordnet (offen / in Arbeit / erledigt / archiviert), damit Berichte projektübergreifend funktionieren. Behalte mindestens einen je Kategorie. Archivierte Arbeit zählt nirgends mit und bleibt ausgeblendet, sofern nicht angefordert.",
  "Archived": "Archiviert",
  "Also show tasks in an archived status. Remembered, and shared by the task views and the board.": "Auch Aufgaben in einem archivierten Status anzeigen. Die Wahl wird gemerkt und von den Aufgabenansichten und dem Board geteilt.",
  "Upload failed": "Hochladen fehlgeschlagen",
  "Uploading 1 file…": "1 Datei wird hochgeladen…",
  "Uploading {n} files…": "{n} Dateien werden hochgeladen…",
  "Waterfall": "Wasserfall",
  "Lay linked tasks out left to right: any task that overlaps what its links allow moves later (keeping its length), then rows are ordered by start, linked ones in link order. Done and archived tasks stay put. Saved; press again after changes.": "Verknüpfte Aufgaben von links nach rechts anordnen: Jede Aufgabe, die sich mit ihren Verknüpfungen überschneidet, wird nach hinten verschoben (Dauer bleibt), dann werden die Zeilen nach Start geordnet, verknüpfte in Verknüpfungsreihenfolge. Erledigte und archivierte Aufgaben bleiben. Wird gespeichert; nach Änderungen erneut drücken.",
  "Waterfall:": "Wasserfall:",
  "in a comment": "in einem Kommentar",
  "rescheduled": "verschoben",
  "reordered": "neu geordnet",
  "Already a waterfall: nothing to change": "Bereits ein Wasserfall: nichts zu ändern",
  "Could not reschedule the tasks": "Die Aufgaben konnten nicht neu geplant werden",
  "Auto-schedule:": "Automatische Planung:",
  "Already scheduled: nothing to change": "Bereits geplant: nichts zu ändern",
  "Auto-schedule replans every open task: in-progress work first, then linked tasks as soon as their links allow and others from today, so nobody gets two tasks at once. Continue?": "Die automatische Planung plant jede offene Aufgabe neu: zuerst laufende Arbeit, dann verknüpfte Aufgaben, sobald ihre Verknüpfungen es erlauben, und andere ab heute, sodass niemand zwei Aufgaben gleichzeitig hat. Fortfahren?",
  "Plan the open tasks as soon as possible: linked ones right after their links allow, unlinked past or undated ones from today (undated take their estimate at 8h a day, or 5 days), future unlinked ones keep their start. Each person's tasks are queued, in-progress first and then by priority, so they never overlap, counting their other projects. Done and archived tasks stay put. Saved.": "Die offenen Aufgaben so früh wie möglich planen: verknüpfte direkt, sobald ihre Verknüpfungen es erlauben, unverknüpfte vergangene oder undatierte ab heute (undatierte mit ihrer Schätzung zu 8 h pro Tag, sonst 5 Tage), zukünftige unverknüpfte behalten ihren Start. Die Aufgaben jeder Person werden eingereiht, zuerst laufende, dann nach Priorität, damit sie sich nie überschneiden, auch über andere Projekte. Erledigte und archivierte Aufgaben bleiben. Wird gespeichert.",
  "working days": "Arbeitstage",
  "estimated": "geschätzt",
  "Edit": "Bearbeiten",
  "Edit person": "Person bearbeiten",
  "Edit your comment; the previous text is kept as history": "Bearbeite deinen Kommentar; der vorherige Text bleibt als Verlauf erhalten",
  "Elapsed": "Verstrichen",
  "Email": "E-Mail",
  "End this session and return to the sign-in page (other devices stay signed in)": "Diese Sitzung beenden und zur Anmeldeseite zurückkehren (andere Geräte bleiben angemeldet)",
  "Ends": "Endet",
  "Enter the 6-digit code from your authenticator app, or one of your recovery codes.": "Gib den 6-stelligen Code aus deiner Authenticator-App oder einen deiner Wiederherstellungscodes ein.",
  "Est.": "Schätz.",
  "Estimate (h)": "Schätzung (h)",
  "Every project-week approved": "Alle Projektwochen freigegeben",
  "Everyone": "Alle",
  "Everyone (admin)": "Alle (Admin)",
  "Everyone in the range is approved — download the payroll CSV": "Alle im Zeitraum sind freigegeben — Lohn-CSV herunterladen",
  "Everything on this person's record. Changes are audit-logged against your name.": "Alles im Datensatz dieser Person. Änderungen werden unter deinem Namen im Audit-Log festgehalten.",
  "Examples:": "Beispiele:",
  "Excludes people who still have unapproved weeks; they are named in the file header": "Schließt Personen mit noch nicht freigegebenen Wochen aus; sie werden im Dateikopf genannt",
  "Expand": "Ausklappen",
  "Expand this card to see details": "Diese Karte ausklappen, um Details zu sehen",
  "Expand this section (remembered for you)": "Diesen Abschnitt ausklappen (wird für dich gemerkt)",
  "Expires": "Läuft ab",
  "External calendars (in)": "Externe Kalender (eingehend)",
  "Feature flags": "Feature-Flags",
  "Field": "Feld",
  "Filter the list by project code or name": "Liste nach Projektcode oder -name filtern",
  "Final step: deactivate the account now": "Letzter Schritt: Konto jetzt deaktivieren",
  "For an integration such as Claude Code rather than a colleague: it stays out of payroll, timesheets and scheduled reports.": "Für eine Integration wie Claude Code statt für eine Kollegin oder einen Kollegen: bleibt außerhalb von Lohn, Stundenzetteln und geplanten Berichten.",
  "From": "Von",
  "From your calendar today": "Aus deinem heutigen Kalender",
  "Global category this column maps to, so cross-project reports keep working": "Globale Kategorie, der diese Spalte zugeordnet ist, damit projektübergreifende Berichte weiter funktionieren",
  "Google did not grant offline access — remove ADKOM PM under your Google account’s third-party access, then connect again.": "Google hat keinen Offline-Zugriff gewährt — entferne ADKOM PM unter dem Drittanbieterzugriff deines Google-Kontos und verbinde erneut.",
  "Grant read-only access; today's meetings become one-click time entry suggestions": "Nur-Lese-Zugriff gewähren; heutige Termine werden zu Ein-Klick-Vorschlägen für Zeiteinträge",
  "Group by": "Gruppieren nach",
  "Group the board into rows by assignee, epic or priority": "Board in Zeilen nach Zuständigem, Epic oder Priorität gruppieren",
  "Has unapproved weeks": "Hat nicht freigegebene Wochen",
  "Hidden projects are a personal view preference; nothing about the project changes": "Ausgeblendete Projekte sind eine persönliche Ansichtseinstellung; am Projekt ändert sich nichts",
  "Hide subtasks": "Unteraufgaben ausblenden",
  "Show only tasks in progress, hiding the backlog and done. Remembered, and shared by the task views.": "Nur Aufgaben in Bearbeitung anzeigen, Backlog und erledigte ausblenden. Die Wahl wird gemerkt und von den Aufgabenansichten geteilt.",
  "Hide tasks that are done. Remembered, and shared by the task views.": "Erledigte Aufgaben ausblenden. Die Wahl wird gemerkt und von den Aufgabenansichten geteilt.",
  "Show backlog": "Backlog anzeigen",
  "With \"Active only\" on, also show tasks still in the backlog. Remembered.": "Bei aktivem \"Nur aktive\" auch Aufgaben im Backlog anzeigen. Die Wahl wird gemerkt.",
  "Hide this milestone's discussion": "Diskussion zu diesem Meilenstein ausblenden",
  "Hide this project from your lists (just for you; the project is unchanged)": "Dieses Projekt aus deinen Listen ausblenden (nur für dich; das Projekt bleibt unverändert)",
  "Hide this project's tasks": "Aufgaben dieses Projekts ausblenden",
  "Hours": "Stunden",
  "Hours (30d)": "Stunden (30 T)",
  "Hours for other members are visible to project administrators and managers.": "Stunden anderer Mitglieder sind für Projektadministratoren und Manager sichtbar.",
  "Hours per week": "Stunden pro Woche",
  "Hours/wk": "Std./Wo",
  "How much of their time the schedule may plan for.": "Wie viel ihrer Zeit der Zeitplan einplanen darf.",
  "IP allowlist set by an administrator": "IP-Zulassungsliste, von einem Administrator festgelegt",
  "Identifies this project's tasks on portfolio boards and Gantts": "Kennzeichnet die Aufgaben dieses Projekts auf Portfolio-Boards und -Gantts",
  "Import": "Importieren",
  "Import in order: people → projects → tasks.": "Reihenfolge beim Import: Personen → Projekte → Aufgaben.",
  "In progress": "In Arbeit",
  "Include accounts used by integrations, which are hidden by default": "Konten von Integrationen einblenden, die standardmäßig verborgen sind",
  "Invite": "Einladen",
  "Invite colleagues and manage roles.": "Lade Kolleginnen und Kollegen ein und verwalte Rollen.",
  "Invite for": "Einladung für",
  "Issue a token for this person and show it once": "Ein Token für diese Person ausstellen und einmal anzeigen",
  "Issue or revoke tokens that act as this person through the API": "Tokens ausstellen oder widerrufen, die über die API im Namen dieser Person handeln",
  "Issues assigned to this GitHub user become tasks assigned to them.": "Issues, die diesem GitHub-Benutzer zugewiesen sind, werden zu Aufgaben für diese Person.",
  "Job title": "Berufsbezeichnung",
  "Jump to the current week": "Zur aktuellen Woche springen",
  "Jump to the top of the page": "Zum Seitenanfang springen",
  "Jump to top": "Nach oben",
  "Kanban board across every project in the portfolio": "Kanban-Board über alle Projekte des Portfolios",
  "Kanban board: drag cards between status columns": "Kanban-Board: Karten zwischen Statusspalten ziehen",
  "Keep": "Behalten",
  "Keep the account": "Konto behalten",
  "Keep — count the idle time as work": "Behalten — Leerlaufzeit als Arbeit zählen",
  "Keeps this account out of payroll, timesheets and scheduled reports.": "Hält dieses Konto aus Lohn, Stundenzetteln und geplanten Berichten heraus.",
  "Key": "Schlüssel",
  "Kind": "Art",
  "Label": "Bezeichnung",
  "Language": "Sprache",
  "Last": "Zuletzt",
  "Last active": "Zuletzt aktiv",
  "Last run": "Letzter Lauf",
  "Last sign-in": "Letzte Anmeldung",
  "Last used": "Zuletzt verwendet",
  "Lead (d)": "Durchlauf (T)",
  "Leave": "Abwesenheit",
  "Leave it empty to follow the organisation's working week.": "Leer lassen, um der Arbeitswoche der Organisation zu folgen.",
  "Line": "Zeile",
  "List": "Liste",
  "Loading…": "Lädt…",
  "Log time →": "Zeit erfassen →",
  "Logged": "Erfasst",
  "Managed by": "Verwaltet von",
  "Markdown · type @ to mention someone · Ctrl-Enter posts": "Markdown · @ tippen, um jemanden zu erwähnen · Strg-Enter veröffentlicht",
  "Median cycle time": "Mediane Zykluszeit",
  "Median lead time": "Mediane Durchlaufzeit",
  "Member": "Mitglied",
  "Members": "Mitglieder",
  "Mention someone": "Jemanden erwähnen",
  "Milestone": "Meilenstein",
  "Milestones": "Meilensteine",
  "Milestone…": "Meilenstein…",
  "Mine open": "Meine offenen",
  "Month": "Monat",
  "Month view of due dates, milestones and external calendars": "Monatsansicht von Fälligkeiten, Meilensteinen und externen Kalendern",
  "More actions for this row": "Weitere Aktionen für diese Zeile",
  "Move this status up one place": "Diesen Status eine Position nach oben",
  "Move up": "Nach oben",
  "Moving a project out of a portfolio is refused while it has cross-project links": "Ein Projekt kann nicht aus einem Portfolio entfernt werden, solange es projektübergreifende Verknüpfungen hat",
  "My private projects": "Meine privaten Projekte",
  "My reports": "Meine Berichte",
  "My requests": "Meine Anträge",
  "My tasks": "Meine Aufgaben",
  "New milestone": "Neuer Meilenstein",
  "New password": "Neues Passwort",
  "New portfolio": "Neues Portfolio",
  "New portfolio name": "Name des neuen Portfolios",
  "New project": "Neues Projekt",
  "New status": "Neuer Status",
  "New subtask": "Neue Unteraufgabe",
  "New task": "Neue Aufgabe",
  "New task in": "Neue Aufgabe in",
  "New task title": "Titel der neuen Aufgabe",
  "New timer": "Neuer Timer",
  "Next milestone": "Nächster Meilenstein",
  "Next month": "Nächster Monat",
  "Next run": "Nächster Lauf",
  "Next week": "Nächste Woche",
  "No comments yet.": "Noch keine Kommentare.",
  "No completed work in the window yet.": "Noch keine abgeschlossene Arbeit im Zeitfenster.",
  "No cost rate yet.": "Noch kein Kostensatz.",
  "No data.": "Keine Daten.",
  "No earlier versions.": "Keine früheren Fassungen.",
  "No feed link yet.": "Noch kein Feed-Link.",
  "No hours budget set.": "Kein Stundenbudget gesetzt.",
  "No members yet.": "Noch keine Mitglieder.",
  "No milestones yet.": "Noch keine Meilensteine.",
  "No money budget set.": "Kein Geldbudget gesetzt.",
  "No open milestones with a due date.": "Keine offenen Meilensteine mit Fälligkeitsdatum.",
  "No portfolios yet.": "Noch keine Portfolios.",
  "No projects filed here yet.": "Noch keine Projekte hier zugeordnet.",
  "No projects in this portfolio yet.": "Noch keine Projekte in diesem Portfolio.",
  "No projects match.": "Keine passenden Projekte.",
  "No projects yet.": "Noch keine Projekte.",
  "No projects.": "Keine Projekte.",
  "No tasks yet.": "Noch keine Aufgaben.",
  "No tasks.": "Keine Aufgaben.",
  "No time in this range.": "Keine Zeit in diesem Zeitraum.",
  "No time in this window.": "Keine Zeit in diesem Zeitfenster.",
  "No time matches.": "Keine passende Zeit.",
  "No tokens yet.": "Noch keine Tokens.",
  "Non-billable only": "Nur nicht abrechenbar",
  "None": "Keine",
  "None yet.": "Noch nichts.",
  "Not available — approvals are for project administrators.": "Nicht verfügbar — Freigaben sind Projektadministratoren vorbehalten.",
  "Not configured on this server.": "Auf diesem Server nicht konfiguriert.",
  "Not enough history yet for a trend — the weekly chart appears after two weeks of entries.": "Noch nicht genug Verlauf für einen Trend — das Wochendiagramm erscheint nach zwei Wochen mit Einträgen.",
  "Not enough history yet for trends and forecasts — they firm up after a couple of weeks of tasks moving. What is here is exact, just short.": "Noch nicht genug Verlauf für Trends und Prognosen — sie festigen sich nach ein paar Wochen Aufgabenbewegung. Was hier steht, ist exakt, nur kurz.",
  "Not enough history yet — the chart appears once two project weeks have entries.": "Noch nicht genug Verlauf — das Diagramm erscheint, sobald zwei Projektwochen Einträge haben.",
  "Not submitted": "Nicht eingereicht",
  "Note": "Notiz",
  "Note (optional)": "Notiz (optional)",
  "Note saved onto the entry": "Notiz wird auf dem Eintrag gespeichert",
  "Note saved onto the time entry when you stop": "Notiz wird beim Stoppen auf dem Zeiteintrag gespeichert",
  "Notes": "Notizen",
  "Nothing assigned to you.": "Dir ist nichts zugewiesen.",
  "Nothing completed yet.": "Noch nichts abgeschlossen.",
  "Nothing here.": "Hier ist nichts.",
  "Nothing logged yet.": "Noch nichts erfasst.",
  "Nothing recorded yet.": "Noch nichts aufgezeichnet.",
  "Nothing to preview yet.": "Noch nichts für die Vorschau.",
  "Nothing yet.": "Noch nichts.",
  "Notifications": "Benachrichtigungen",
  "Now click the task that must wait for": "Klicke jetzt auf die Aufgabe, die warten muss auf",
  "On enter": "Beim Betreten",
  "One submission per project per week, in each project's own timezone.": "Eine Einreichung pro Projekt und Woche, jeweils in der Zeitzone des Projekts.",
  "Only ephemeral records are ever purged. Business history — time entries, approvals, tasks, the audit log, status transitions — is never touched.": "Nur kurzlebige Datensätze werden bereinigt. Die Geschäftshistorie — Zeiteinträge, Freigaben, Aufgaben, das Audit-Protokoll, Statusübergänge — wird nie angetastet.",
  "Only you can see these. Drag to prioritize.": "Nur du kannst diese sehen. Ziehen, um zu priorisieren.",
  "Open People": "Personen öffnen",
  "Open People: directory, roles, invites": "Personen öffnen: Verzeichnis, Rollen, Einladungen",
  "Open Projects": "Projekte öffnen",
  "Open Reports to slice logged time": "Berichte öffnen, um erfasste Zeit auszuwerten",
  "Open portfolio →": "Portfolio öffnen →",
  "Open tasks": "Offene Aufgaben",
  "Open the Gantt chart": "Gantt-Diagramm öffnen",
  "Open the Kanban board": "Kanban-Board öffnen",
  "Open the Time page: edit timers, notes, tasks": "Zeit-Seite öffnen: Timer, Notizen, Aufgaben bearbeiten",
  "Open the portfolio": "Portfolio öffnen",
  "Open the portfolio: shared board, list and Gantt across its projects": "Portfolio öffnen: gemeinsames Board, Liste und Gantt über seine Projekte",
  "Open the project": "Projekt öffnen",
  "Open the task": "Aufgabe öffnen",
  "Outstanding": "Ausstehend",
  "Overdue": "Überfällig",
  "Overview": "Übersicht",
  "Parent": "Übergeordnet",
  "Password": "Passwort",
  "Paste CSV here…": "CSV hier einfügen…",
  "Pause this timer; time is kept": "Diesen Timer pausieren; die Zeit bleibt erhalten",
  "Pause; time is kept": "Pause; die Zeit bleibt erhalten",
  "Payroll export": "Lohnexport",
  "Pending": "Ausstehend",
  "People": "Personen",
  "Per-project feeds:": "Feeds je Projekt:",
  "Permanent. Create a new project to use a different zone.": "Dauerhaft. Lege ein neues Projekt an, um eine andere Zone zu verwenden.",
  "Pick the range by": "Zeitraum wählen nach",
  "Portfolio manager": "Portfolio-Manager",
  "Portfolio not found, or you do not have access.": "Portfolio nicht gefunden, oder du hast keinen Zugriff.",
  "Portfolio role": "Portfolio-Rolle",
  "Portfolio roles grant access to the merged views; task edits still follow each project's own membership.": "Portfolio-Rollen gewähren Zugriff auf die zusammengeführten Ansichten; Aufgabenänderungen richten sich weiterhin nach der Mitgliedschaft im jeweiligen Projekt.",
  "Portfolios don't affect approvals — they add a shared board, list and Gantt, and cross-project links.": "Portfolios beeinflussen keine Freigaben — sie ergänzen ein gemeinsames Board, eine Liste und ein Gantt sowie projektübergreifende Verknüpfungen.",
  "Portfolios don't affect permissions or approvals — they are purely for organising and reporting.": "Portfolios beeinflussen weder Berechtigungen noch Freigaben — sie dienen nur der Ordnung und dem Berichtswesen.",
  "Portfolios →": "Portfolios →",
  "Post the comment": "Kommentar veröffentlichen",
  "Post the comment (Ctrl-Enter)": "Kommentar veröffentlichen (Strg-Enter)",
  "Prev": "Zurück",
  "Preview": "Vorschau",
  "Previous month": "Vorheriger Monat",
  "Previous week": "Vorherige Woche",
  "Priority": "Priorität",
  "Priority…": "Priorität…",
  "Private projects filed here that only their owners can see": "Hier zugeordnete private Projekte, die nur ihre Eigentümer sehen können",
  "Private — only you can see this project": "Privat — nur du kannst dieses Projekt sehen",
  "Private — only you will see this project": "Privat — nur du wirst dieses Projekt sehen",
  "Progress": "Fortschritt",
  "Project": "Projekt",
  "Project colour": "Projektfarbe",
  "Project not found, or you do not have access.": "Projekt nicht gefunden oder kein Zugriff.",
  "Project not found.": "Projekt nicht gefunden.",
  "Project role": "Projektrolle",
  "Project the new task belongs to": "Projekt, zu dem die neue Aufgabe gehört",
  "Projected finish": "Prognostiziertes Ende",
  "Projects": "Projekte",
  "Projects not yet in a portfolio that you may update": "Projekte, die du bearbeiten darfst und die noch in keinem Portfolio sind",
  "Projects you are a member of.": "Projekte, in denen du Mitglied bist.",
  "Projects you can see. Managers and admins see all.": "Projekte, die du sehen kannst. Manager und Admins sehen alle.",
  "Purge immediately using the currently saved policy (not unsaved edits) and record the counts above": "Sofort mit der aktuell gespeicherten Richtlinie bereinigen (nicht mit ungespeicherten Änderungen) und die Zahlen oben festhalten",
  "Push successors when a task moves": "Nachfolger verschieben, wenn eine Aufgabe verschoben wird",
  "Range": "Zeitraum",
  "Rates are visible to managers and administrators.": "Sätze sind für Manager und Administratoren sichtbar.",
  "Read this first.": "Bitte zuerst lesen.",
  "Read tokens can only look; write tokens can also create and change tasks, links, milestones and time entries. Everything a token does is audited as you, marked with the token's name.": "Lese-Tokens können nur ansehen; Schreib-Tokens können außerdem Aufgaben, Verknüpfungen, Meilensteine und Zeiteinträge anlegen und ändern. Alles, was ein Token tut, wird als du protokolliert, gekennzeichnet mit dem Token-Namen.",
  "Read-only: today’s meetings appear as one-click suggestions on the Time page. Your entries flow back to any calendar through the": "Nur lesend: heutige Termine erscheinen als Ein-Klick-Vorschläge auf der Zeit-Seite. Deine Einträge fließen über den",
  "Read: look only. Write: create and change tasks, links, milestones and time": "Lesen: nur ansehen. Schreiben: Aufgaben, Verknüpfungen, Meilensteine und Zeit anlegen und ändern",
  "Ready": "Bereit",
  "Recently completed": "Kürzlich abgeschlossen",
  "Regenerate": "Neu erzeugen",
  "Regenerate link": "Link neu erzeugen",
  "Regenerate recovery codes": "Wiederherstellungscodes neu erzeugen",
  "Regenerate the secret link (old link stops working)": "Geheimen Link neu erzeugen (alter Link funktioniert nicht mehr)",
  "Remove": "Entfernen",
  "Remove item": "Punkt entfernen",
  "Remove this calendar": "Diesen Kalender entfernen",
  "Remove this checklist item": "Diesen Checklistenpunkt entfernen",
  "Remove this comment; its replies stay": "Diesen Kommentar entfernen; die Antworten darauf bleiben",
  "Repeats": "Wiederholt sich",
  "Reply": "Antworten",
  "Reply in this thread": "In diesem Thread antworten",
  "Report name": "Berichtsname",
  "Reports": "Berichte",
  "Request": "Beantragen",
  "Request failed": "Anfrage fehlgeschlagen",
  "Request leave": "Abwesenheit beantragen",
  "Reset your password": "Passwort zurücksetzen",
  "Result": "Ergebnis",
  "Resume": "Fortsetzen",
  "Resume (pauses the running timer)": "Fortsetzen (pausiert den laufenden Timer)",
  "Resume this timer (pauses the running one)": "Diesen Timer fortsetzen (pausiert den laufenden)",
  "Retake baseline": "Baseline neu aufnehmen",
  "Retention": "Aufbewahrung",
  "Return the week with a note; the person edits and resubmits": "Woche mit Notiz zurückgeben; die Person bearbeitet und reicht erneut ein",
  "Revoke": "Widerrufen",
  "Revoke the token \"{name}\"? Anything using it stops working immediately.": "Das Token „{name}“ widerrufen? Alles, was es nutzt, hört sofort auf zu funktionieren.",
  "Revoked:": "Widerrufen:",
  "Role": "Rolle",
  "Run this report automatically on the chosen cadence and deliver it by email/notification": "Diesen Bericht automatisch im gewählten Rhythmus ausführen und per E-Mail/Benachrichtigung zustellen",
  "Save": "Speichern",
  "Save every change on this record": "Alle Änderungen an diesem Datensatz speichern",
  "Save policy": "Richtlinie speichern",
  "Save policy stores the numbers for the nightly run. Run now purges immediately with the saved policy.": "„Richtlinie speichern“ speichert die Zahlen für den nächtlichen Lauf. „Jetzt ausführen“ bereinigt sofort mit der gespeicherten Richtlinie.",
  "Save the current grouping and filters under a name": "Aktuelle Gruppierung und Filter unter einem Namen speichern",
  "Save these recovery codes now.": "Speichere diese Wiederherstellungscodes jetzt.",
  "Saved reports…": "Gespeicherte Berichte…",
  "Saved ✓": "Gespeichert ✓",
  "Saved.": "Gespeichert.",
  "Schedule": "Planen",
  "Schedule end": "Geplantes Ende",
  "Schedule settings per project": "Planungseinstellungen je Projekt",
  "Scheduled reports": "Geplante Berichte",
  "Scope": "Umfang",
  "Scroll the timeline back to today": "Zeitleiste zurück zu heute scrollen",
  "Search": "Suchen",
  "Search code or name…": "Code oder Name suchen…",
  "Search…": "Suchen…",
  "Send the request to your line manager (some types are approved automatically)": "Antrag an deinen Vorgesetzten senden (einige Arten werden automatisch genehmigt)",
  "Send them a password reset link from the directory when they are ready to sign in.": "Schick ihnen aus dem Verzeichnis einen Link zum Zurücksetzen, sobald sie sich anmelden sollen.",
  "Send them this link — it is shown once and expires in 7 days:": "Sende diesen Link — er wird einmal angezeigt und läuft in 7 Tagen ab:",
  "Send this project-week to the project administrator for approval; you can withdraw until they decide": "Diese Projektwoche zur Freigabe an den Projektadministrator senden; bis zur Entscheidung kannst du sie zurückziehen",
  "Sent back": "Zurückgegeben",
  "Service account": "Dienstkonto",
  "Set a new password for": "Neues Passwort setzen für",
  "Set a password": "Passwort festlegen",
  "Set status…": "Status setzen…",
  "Set the task and a note when you start, or edit them in the list.": "Lege Aufgabe und Notiz beim Start fest oder bearbeite sie in der Liste.",
  "Set up your account": "Konto einrichten",
  "Settings": "Einstellungen",
  "Share with project": "Mit Projekt teilen",
  "Show": "Anzeigen",
  "Show archived": "Archivierte anzeigen",
  "Show failed sign-in attempts": "Fehlgeschlagene Anmeldeversuche anzeigen",
  "Show service accounts": "Dienstkonten anzeigen",
  "Show sign-in attempts": "Anmeldeversuche anzeigen",
  "Show subtasks": "Unteraufgaben anzeigen",
  "Show the audit log": "Audit-Protokoll anzeigen",
  "Show the comment formatted, as it will appear": "Den Kommentar formatiert anzeigen, so wie er erscheinen wird",
  "Show this project in your lists again": "Dieses Projekt wieder in deinen Listen anzeigen",
  "Show this project's tasks": "Aufgaben dieses Projekts anzeigen",
  "Show what this comment said before it was edited": "Anzeigen, was dieser Kommentar vor der Bearbeitung sagte",
  "Shows their day in the right hours; it never changes which week an entry belongs to.": "Zeigt ihren Tag in den richtigen Stunden; ändert nie, zu welcher Woche ein Eintrag gehört.",
  "Sign in": "Anmelden",
  "Sign in with your device's fingerprint, face or PIN, or a hardware key — no password or code needed. Passkeys are phishing-resistant.": "Melde dich mit Fingerabdruck, Gesicht oder PIN deines Geräts oder einem Hardware-Schlüssel an — ohne Passwort oder Code. Passkeys sind phishing-resistent.",
  "Sign out": "Abmelden",
  "Signed in": "Angemeldet",
  "Signing in…": "Anmeldung…",
  "Since": "Seit",
  "Sortable table of tasks across every project in the portfolio": "Sortierbare Tabelle der Aufgaben aller Projekte im Portfolio",
  "Sortable table of tasks with bulk edit and saved views": "Sortierbare Aufgabentabelle mit Massenbearbeitung und gespeicherten Ansichten",
  "Start (or switch) your timer for this project onto this task; any running timer pauses": "Deinen Timer für dieses Projekt auf diese Aufgabe starten (oder umschalten); ein laufender Timer pausiert",
  "Start a timer for this project (pauses any running timer)": "Timer für dieses Projekt starten (pausiert jeden laufenden Timer)",
  "Start timer": "Timer starten",
  "Start timer on this task": "Timer für diese Aufgabe starten",
  "Starts": "Beginnt",
  "State": "Zustand",
  "Stop and save": "Stoppen und speichern",
  "Stop and save one time entry for the total": "Stoppen und einen Zeiteintrag über die Gesamtdauer speichern",
  "Stop and save one time entry for the total on this project": "Stoppen und einen Zeiteintrag über die Gesamtdauer in diesem Projekt speichern",
  "Stop anything using this token, immediately": "Alles, was dieses Token nutzt, sofort stoppen",
  "Stop at idle — save up to the idle moment and stop": "Bei Leerlauf stoppen — bis zum Leerlaufmoment speichern und stoppen",
  "Stop reading your Google Calendar": "Google Kalender nicht mehr lesen",
  "Stop the timer running on this task and save one time entry": "Den auf dieser Aufgabe laufenden Timer stoppen und einen Zeiteintrag speichern",
  "Stop timer": "Timer stoppen",
  "Store these numbers as the policy; the nightly purge uses them from its next run": "Diese Zahlen als Richtlinie speichern; die nächtliche Bereinigung nutzt sie ab dem nächsten Lauf",
  "Subscribe": "Abonnieren",
  "Subscribe your calendar app to this link to see your tasks (due dates), leave, your projects' milestones and your last 90 days of time entries.": "Abonniere diesen Link in deiner Kalender-App, um deine Aufgaben (Fälligkeiten), Abwesenheiten, die Meilensteine deiner Projekte und deine Zeiteinträge der letzten 90 Tage zu sehen.",
  "Subscribe your calendar app to your tasks, leave, milestones and recent time entries.": "Abonniere deine Aufgaben, Abwesenheiten, Meilensteine und jüngsten Zeiteinträge in deiner Kalender-App.",
  "Swimlanes": "Schwimmbahnen",
  "System state, the audit trail, and sign-in activity. People and invites are under": "Systemzustand, Audit-Trail und Anmeldeaktivität. Personen und Einladungen findest du unter",
  "Take baseline": "Baseline aufnehmen",
  "Take the project out of this portfolio (the project itself is unchanged)": "Das Projekt aus diesem Portfolio entfernen (das Projekt selbst bleibt unverändert)",
  "Take the submission back to edit the week; resubmit when ready": "Einreichung zurücknehmen, um die Woche zu bearbeiten; danach erneut einreichen",
  "Task": "Aufgabe",
  "Task (optional)": "Aufgabe (optional)",
  "Task this timer is for (optional)": "Aufgabe, für die dieser Timer läuft (optional)",
  "Task title": "Aufgabentitel",
  "Tasks": "Aufgaben",
  "Tasks can't move between projects": "Aufgaben können nicht zwischen Projekten verschoben werden",
  "Tasks live inside projects; open Projects": "Aufgaben gehören zu Projekten; öffne Projekte",
  "Team (last 30 days)": "Team (letzte 30 Tage)",
  "That does not look like a valid zone.": "Das sieht nicht nach einer gültigen Zone aus.",
  "The calendar's public iCal URL": "Die öffentliche iCal-URL des Kalenders",
  "The link is a secret — anyone holding it can read your feed. Regenerate it if it leaks.": "Der Link ist geheim — wer ihn hat, kann deinen Feed lesen. Erzeuge ihn neu, falls er durchsickert.",
  "The numbers below are the": "Die Zahlen unten sind die",
  "The person accountable for the portfolio; always a portfolio administrator": "Die für das Portfolio verantwortliche Person; immer ein Portfolio-Administrator",
  "The token is shown once, when you create it. Revoke it here if it leaks.": "Der Token wird nur einmal angezeigt, beim Erstellen. Widerrufe ihn hier, falls er durchsickert.",
  "Then start Claude Code and ask it, for example, \"what is overdue across my portfolio?\" or \"plan the importer epic in DEN with four tasks and link them\".": "Starte dann Claude Code und frag zum Beispiel: „Was ist in meinem Portfolio überfällig?“ oder „Plane das Importer-Epic in DEN mit vier Aufgaben und verknüpfe sie“.",
  "There is no password yet, so nobody can sign in as them. Issue a password reset link from the directory when they are ready.": "Es gibt noch kein Passwort, also kann sich niemand als diese Person anmelden. Stelle aus dem Verzeichnis einen Link zum Zurücksetzen aus, sobald sie so weit ist.",
  "They can sign in with the password you set.": "Sie können sich mit dem Passwort anmelden, das du gesetzt hast.",
  "This account can only be used from these addresses (set by an administrator):": "Dieses Konto kann nur von diesen Adressen aus verwendet werden (von einem Administrator festgelegt):",
  "This browser does not support passkeys.": "Dieser Browser unterstützt keine Passkeys.",
  "This invite is invalid or has expired. Ask an administrator for a new one.": "Diese Einladung ist ungültig oder abgelaufen. Bitte einen Administrator um eine neue.",
  "This password is shown once and will not be shown again. Give it to them over a channel you trust; they can change it under Account.": "Dieses Passwort wird einmal angezeigt und danach nie wieder. Gib es über einen vertrauenswürdigen Weg weiter; ändern lässt es sich unter Konto.",
  "Throw this timer away without saving": "Diesen Timer ohne Speichern verwerfen",
  "Time": "Zeit",
  "Time is approved per project, per week, in each project's own timezone.": "Zeit wird pro Projekt und Woche freigegeben, jeweils in der Zeitzone des Projekts.",
  "Time off is approved by your line manager and reduces your available capacity for that week — it never counts as hours worked.": "Abwesenheit wird von deinem Vorgesetzten genehmigt und verringert deine verfügbare Kapazität in dieser Woche — sie zählt nie als Arbeitszeit.",
  "Timeline across projects: cross-project links, critical path": "Zeitleiste über Projekte hinweg: projektübergreifende Verknüpfungen, kritischer Pfad",
  "Timeline: drag bars, link dependencies, critical path, baseline": "Zeitleiste: Balken ziehen, Abhängigkeiten verknüpfen, kritischer Pfad, Baseline",
  "Timesheets": "Stundenzettel",
  "Timezone": "Zeitzone",
  "Timezone of truth": "Referenz-Zeitzone",
  "Title": "Titel",
  "Title of the new task; you can fill in the rest from the task editor": "Titel der neuen Aufgabe; den Rest kannst du im Aufgabeneditor ausfüllen",
  "To": "Bis",
  "To confirm, type your name exactly:": "Zur Bestätigung gib deinen Namen exakt ein:",
  "To connect Claude Code as this account, put the token in the shell and add the server once:": "Um Claude Code als dieses Konto zu verbinden, leg das Token in die Shell und füge den Server einmal hinzu:",
  "To do": "Offen",
  "To use it from Claude Code, put it in your shell and add the server once:": "Um ihn aus Claude Code zu nutzen, lege ihn in deiner Shell ab und füge den Server einmal hinzu:",
  "Token": "Token",
  "Token name, e.g. Claude Code": "Name des Tokens, z. B. Claude Code",
  "Token name, e.g. Claude Code on my laptop": "Token-Name, z. B. Claude Code auf meinem Laptop",
  "Top": "Oben",
  "Total": "Gesamt",
  "Turn off": "Ausschalten",
  "Turn off authenticator": "Authenticator ausschalten",
  "Turn on": "Einschalten",
  "Type": "Typ",
  "Type @ to mention someone · Ctrl-Enter posts": "@ tippen, um jemanden zu erwähnen · Strg-Enter veröffentlicht",
  "Type a command, project, task key, or name…  (Ctrl-K toggles)": "Befehl, Projekt, Aufgabenschlüssel oder Namen eingeben…  (Strg-K schaltet um)",
  "Type your display name exactly to enable the final button": "Gib deinen Anzeigenamen exakt ein, um die letzte Schaltfläche freizuschalten",
  "Unarchive": "Archivierung aufheben",
  "Unassigned": "Nicht zugewiesen",
  "Unlock an approved week for edits; requires a reason, recorded in the audit log, and notifies the person": "Freigegebene Woche zur Bearbeitung entsperren; erfordert eine Begründung, wird im Audit-Protokoll festgehalten und benachrichtigt die Person",
  "Unshare": "Nicht mehr teilen",
  "Upcoming milestones": "Anstehende Meilensteine",
  "Update password": "Passwort aktualisieren",
  "Upload": "Hochladen",
  "Use them to try a change with a few people first, or to switch a feature off quickly if it misbehaves.": "Nutze sie, um eine Änderung zuerst mit wenigen Personen zu testen oder eine Funktion schnell abzuschalten, wenn sie Probleme macht.",
  "Velocity (estimate hours done per week)": "Velocity (erledigte Schätzstunden pro Woche)",
  "Velocity per week": "Velocity pro Woche",
  "Verify": "Prüfen",
  "Views…": "Ansichten…",
  "WIP limit": "WIP-Limit",
  "Week": "Woche",
  "Week of": "Woche vom",
  "Weeks awaiting submission": "Wochen warten auf Einreichung",
  "Weeks from": "Wochen ab",
  "Weeks run Monday→Monday in": "Wochen laufen Montag→Montag in",
  "What": "Was",
  "What did you work on?": "Woran hast du gearbeitet?",
  "What they see the app in until they choose otherwise.": "Die Sprache, in der sie die App sehen, bis sie eine andere wählen.",
  "What this person costs per hour (effective-dated); click to view history or change it": "Was diese Person pro Stunde kostet (mit Gültigkeitsdatum); klicken für Verlauf oder Änderung",
  "When": "Wann",
  "When done, the next occurrence is created with dates shifted.": "Nach Erledigung wird das nächste Vorkommen mit verschobenen Terminen angelegt.",
  "When the token stops working on its own": "Wann der Token von selbst abläuft",
  "Where password resets go. Change it and they are emailed about it.": "Hierhin gehen Passwort-Zurücksetzungen. Änderst du sie, wird die Person per E-Mail benachrichtigt.",
  "Which project the new timer is for": "Für welches Projekt der neue Timer ist",
  "Who": "Wer",
  "Working days per week": "Arbeitstage pro Woche",
  "Write": "Schreiben",
  "Write a comment…": "Kommentar schreiben…",
  "Write a reply…": "Antwort schreiben…",
  "You are not a member of any project yet, so there is nowhere to log time. Ask a project administrator to add you.": "Du bist noch in keinem Projekt Mitglied, daher gibt es nirgends Zeit zu erfassen. Bitte einen Projektadministrator, dich hinzuzufügen.",
  "You become its portfolio manager; add projects and members from the portfolio page, or file a project from its": "Du wirst sein Portfolio-Manager; füge Projekte und Mitglieder auf der Portfolioseite hinzu oder ordne ein Projekt über seine",
  "You can also send them the link directly:": "Du kannst den Link auch direkt schicken:",
  "You can see this project's tasks here but not change them": "Du kannst die Aufgaben dieses Projekts hier sehen, aber nicht ändern",
  "You do not have access to this page.": "Du hast keinen Zugriff auf diese Seite.",
  "You have been invited as": "Du wurdest eingeladen als",
  "You have no line manager set, so requests will wait for an administrator. Ask an admin to set your manager under People.": "Du hast keinen Vorgesetzten hinterlegt, daher warten Anträge auf einen Administrator. Bitte einen Admin, deinen Vorgesetzten unter Personen zu setzen.",
  "You need edit rights in both projects to link them": "Du brauchst Bearbeitungsrechte in beiden Projekten, um sie zu verknüpfen",
  "You sign in with Google, which handles two-factor authentication for you. These options apply to password sign-in.": "Du meldest dich mit Google an, das die Zwei-Faktor-Authentifizierung für dich übernimmt. Diese Optionen gelten für die Passwort-Anmeldung.",
  "You sign in with Google. A password gives you a fallback if Google is unavailable.": "Du meldest dich mit Google an. Ein Passwort dient als Rückfallebene, falls Google nicht verfügbar ist.",
  "Your colleagues.": "Deine Kolleginnen und Kollegen.",
  "Your feed (out)": "Dein Feed (ausgehend)",
  "Your name": "Dein Name",
  "Your own zone, for display. Projects keep their own timezone-of-truth.": "Deine eigene Zone, zur Anzeige. Projekte behalten ihre Referenz-Zeitzone.",
  "Your role": "Deine Rolle",
  "Your role requires a second factor for password sign-in. Set up an": "Deine Rolle erfordert einen zweiten Faktor für die Passwort-Anmeldung. Richte eine",
  "Your week is shown in": "Deine Woche wird angezeigt in",
  "active people": "aktive Personen",
  "active projects": "aktive Projekte",
  "approvals arrive in Phase 3": "Freigaben kommen in Phase 3",
  "archived": "archiviert",
  "assignee: clear": "Zuständig: leeren",
  "assignee: keep": "Zuständig: behalten",
  "audit trail for this project": "Audit-Trail dieses Projekts",
  "billable hours": "abrechenbare Stunden",
  "billed amount": "abgerechneter Betrag",
  "by": "von",
  "change in Settings": "in Einstellungen ändern",
  "closes Monday": "schließt Montag",
  "comments and @mentions about the project as a whole": "Kommentare und @Erwähnungen zum Projekt als Ganzes",
  "correction": "Korrektur",
  "cost": "Kosten",
  "cost / hour": "Kosten / Stunde",
  "created": "erstellt",
  "created → done": "erstellt → erledigt",
  "created. Copy it now — it will not be shown again.": "erstellt. Kopiere ihn jetzt – er wird nicht noch einmal angezeigt.",
  "critical tasks": "kritische Aufgaben",
  "current": "aktuell",
  "current + new + confirm": "aktuell + neu + bestätigen",
  "current 6-digit code": "aktueller 6-stelliger Code",
  "days": "Tage",
  "deleted": "gelöscht",
  "description, dashboard": "Beschreibung, Dashboard",
  "devices signed in as you": "Geräte, die als du angemeldet sind",
  "done": "erledigt",
  "download everything stored about you": "alles herunterladen, was über dich gespeichert ist",
  "due +days": "fällig +Tage",
  "edited": "bearbeitet",
  "edited by": "bearbeitet von",
  "est. h": "Schätz. h",
  "estimate hours": "Schätzstunden",
  "every 2 weeks": "alle 2 Wochen",
  "every day": "täglich",
  "every month": "monatlich",
  "every quarter": "vierteljährlich",
  "every week": "wöchentlich",
  "extra recipients (comma-separated)": "weitere Empfänger (durch Komma getrennt)",
  "failed sign-ins (24h)": "fehlgeschlagene Anmeldungen (24 h)",
  "feed URL, Google Calendar, external calendars": "Feed-URL, Google Kalender, externe Kalender",
  "fingerprint, face, security key": "Fingerabdruck, Gesicht, Sicherheitsschlüssel",
  "for Claude Code and scripts": "für Claude Code und Skripte",
  "from": "von",
  "generate one and show it to me once": "eines erzeugen und mir einmal zeigen",
  "hidden": "ausgeblendet",
  "hours": "Stunden",
  "hours and money caps, alerts": "Stunden- und Geldobergrenzen, Warnungen",
  "hours logged": "erfasste Stunden",
  "hours logged (yours where restricted)": "erfasste Stunden (bei Einschränkung nur deine)",
  "iCal subscription link": "iCal-Abonnementlink",
  "in": "in",
  "in progress": "in Arbeit",
  "kept": "behalten",
  "last 30 days": "letzte 30 Tage",
  "last month": "letzter Monat",
  "last week": "letzte Woche",
  "latest scheduled finish across projects": "spätestes geplantes Ende über alle Projekte",
  "list view, editor, checklists": "Listenansicht, Editor, Checklisten",
  "live sessions": "aktive Sitzungen",
  "logged this week": "diese Woche erfasst",
  "median cycle time (days)": "mediane Zykluszeit (Tage)",
  "median lead time (days)": "mediane Durchlaufzeit (Tage)",
  "migrations": "Migrationen",
  "month to date": "laufender Monat",
  "name, dates, timezone, archive": "Name, Termine, Zeitzone, Archivieren",
  "name, description, portfolio manager, archive": "Name, Beschreibung, Portfolio-Manager, Archivierung",
  "name, language, timezone": "Name, Sprache, Zeitzone",
  "navigate · Enter run · Esc close": "navigieren · Enter ausführen · Esc schließen",
  "never": "nie",
  "never expires": "läuft nie ab",
  "no estimates yet": "noch keine Schätzungen",
  "no rate — billable time counts as unrated": "kein Satz — abrechenbare Zeit zählt als unbewertet",
  "no scheduled tasks yet": "noch keine geplanten Aufgaben",
  "non-billable": "nicht abrechenbar",
  "none yet": "noch keine",
  "none — portfolio views assign a palette colour": "keine — Portfolio-Ansichten vergeben eine Palettenfarbe",
  "none — they cannot sign in yet": "keines — sie können sich noch nicht anmelden",
  "now has an account.": "hat jetzt ein Konto.",
  "off": "aus",
  "office, home…": "Büro, Zuhause…",
  "on": "an",
  "open tasks assigned to me": "mir zugewiesene offene Aufgaben",
  "or set a password": "oder Passwort festlegen",
  "or use a password": "oder mit Passwort",
  "overdue": "überfällig",
  "overdue ·": "überfällig ·",
  "payroll-ready": "lohnbereit",
  "people are": "Personen sind",
  "permanent — read first": "Person ist",
  "person is": "dauerhaft — zuerst lesen",
  "person's zone": "Zone der Person",
  "policy": "Richtlinie",
  "portfolio": "Portfolio",
  "portfolio administrator": "Portfolio-Administrator",
  "portfolio end": "Portfolio-Ende",
  "predecessor": "Vorgänger",
  "priority: keep": "Priorität: behalten",
  "private": "privat",
  "project administrator": "Projekt-Administrator",
  "project zone": "Projektzone",
  "projected finish": "prognostiziertes Ende",
  "projects": "Projekte",
  "rate / hour": "Satz / Stunde",
  "read and write": "Lesen und Schreiben",
  "read only": "nur Lesen",
  "read this once": "einmal lesen",
  "read-only": "nur lesend",
  "rejected — resubmit": "abgelehnt — erneut einreichen",
  "service account": "Dienstkonto",
  "set one now": "jetzt eines setzen",
  "subtask": "Unteraufgabe",
  "synced": "synchronisiert",
  "system": "System",
  "taken": "erstellt am",
  "task count": "Aufgabenanzahl",
  "tasks": "Aufgaben",
  "tasks done": "Aufgaben erledigt",
  "then": "dann",
  "this device": "dieses Gerät",
  "this week": "diese Woche",
  "throughput": "Durchsatz",
  "time entries": "Zeiteinträge",
  "time-based codes (TOTP)": "zeitbasierte Codes (TOTP)",
  "to": "bis",
  "to do": "offen",
  "two-way sync": "bidirektionale Synchronisierung",
  "unassigned": "nicht zugewiesen",
  "updated": "aktualisiert",
  "velocity (h / week)": "Velocity (h / Woche)",
  "via API token": "über API-Token",
  "week start": "Wochenbeginn",
  "weeks awaiting submission": "Wochen warten auf Einreichung",
  "workflow columns and transitions": "Workflow-Spalten und Übergänge",
  "your hours logged": "deine erfassten Stunden",
  "your password": "dein Passwort",
  "zero slack: a delay moves the end date": "kein Puffer: eine Verzögerung verschiebt das Enddatum",
  "{n} people notified": "{n} Personen benachrichtigt",
  "{n} private projects are hidden from these totals.": "{n} private Projekte sind in diesen Summen ausgeblendet.",
  "{n} private projects hidden": "{n} private Projekte ausgeblendet",
  "{n} projects": "{n} Projekte",
  "— (top level)": "— (oberste Ebene)",
  "— no task —": "— keine Aufgabe —",
  "— none —": "— keine —",
  "— unassigned —": "— nicht zugewiesen —",
  "🔒 approved": "🔒 freigegeben",
  "Task completed.": "Aufgabe erledigt.",
  "Task reopened.": "Aufgabe wieder geöffnet.",
  "Board": "Board",
  "Budget": "Budget",
  "Code": "Code",
  "Epic": "Epic",
  "Format": "Format",
  "Gantt": "Gantt",
  "Manager": "Manager",
  "Name": "Name",
  "Pause": "Pause",
  "Person": "Person",
  "Person…": "Person…",
  "Portfolio": "Portfolio",
  "Portfolios": "Portfolios",
  "Status": "Status",
  "Velocity": "Velocity",
  "Zoom": "Zoom",
  "Applies immediately to this browser and every device you sign in on; overrides the browser language.": "Gilt sofort für diesen Browser und jedes Gerät, auf dem du dich anmeldest; überschreibt die Browsersprache.",
  "A confirmation link was sent to the new address (valid 2 days). Your email changes when you open it.": "Ein Bestätigungslink wurde an die neue Adresse gesendet (2 Tage gültig). Deine E-Mail ändert sich, sobald du ihn öffnest.",
  "Cancel it": "Abbrechen",
  "Change email": "E-Mail ändern",
  "Change now": "Jetzt ändern",
  "Change now (with password)": "Jetzt ändern (mit Passwort)",
  "Change the email immediately": "Die E-Mail sofort ändern",
  "Changed. Use the new address next time you sign in.": "Geändert. Verwende die neue Adresse bei der nächsten Anmeldung.",
  "Confirm email": "E-Mail bestätigen",
  "Done — your sign-in email is now": "Fertig — deine Anmelde-E-Mail ist jetzt",
  "Either way the old address is told, and the change is recorded in the audit log.": "In beiden Fällen wird die alte Adresse informiert und die Änderung im Audit-Protokoll festgehalten.",
  "Mail is not configured on this server, so open this link yourself (valid 2 days):": "Auf diesem Server ist kein Mailversand konfiguriert; öffne diesen Link daher selbst (2 Tage gültig):",
  "New email": "Neue E-Mail",
  "Send a confirmation link to the new address": "Bestätigungslink an die neue Adresse senden",
  "Send confirmation link": "Bestätigungslink senden",
  "This account signs in with Google, so its email is managed by Google and cannot be changed here.": "Dieses Konto meldet sich mit Google an; die E-Mail wird von Google verwaltet und kann hier nicht geändert werden.",
  "Verify first": "Zuerst bestätigen",
  "Verify first (send a link)": "Zuerst bestätigen (Link senden)",
  "Waiting for confirmation of": "Warte auf Bestätigung von",
  "Your email is what you sign in with and where notifications are mailed.": "Deine E-Mail ist deine Anmeldung und das Ziel für Benachrichtigungen.",
  "a link is sent to the new address; the change happens when you open it, so a typo can't lock you out.": "ein Link geht an die neue Adresse; die Änderung erfolgt beim Öffnen, sodass dich ein Tippfehler nicht aussperren kann.",
  "enter your current password and the address changes immediately.": "gib dein aktuelles Passwort ein und die Adresse ändert sich sofort.",
  "expires": "läuft ab",
  "A status update is waiting to be sent to GitHub": "Eine Statusaktualisierung wartet auf den Versand an GitHub",
  "API calls left this hour": "API-Aufrufe in dieser Stunde übrig",
  "Assign to matching people": "Passenden Personen zuweisen",
  "Close and reopen issues when task status changes": "Issues schließen und wieder öffnen, wenn sich der Aufgabenstatus ändert",
  "Connect": "Verbinden",
  "Connect a repository to import its issues as tasks. When a task is finished here, the issue is closed on GitHub; when an issue is closed or reopened on GitHub, the task follows.": "Verbinden Sie ein Repository, um seine Issues als Aufgaben zu importieren. Wird eine Aufgabe hier abgeschlossen, wird das Issue auf GitHub geschlossen; wird ein Issue auf GitHub geschlossen oder wieder geöffnet, folgt die Aufgabe.",
  "Connected to": "Verbunden mit",
  "Could not load the GitHub connection.": "Die GitHub-Verbindung konnte nicht geladen werden.",
  "Create missing milestones": "Fehlende Meilensteine anlegen",
  "Disconnect": "Trennen",
  "Disconnect this repository? Existing issue links are kept; nothing is deleted on GitHub.": "Dieses Repository trennen? Bestehende Issue-Verknüpfungen bleiben erhalten; auf GitHub wird nichts gelöscht.",
  "Fine-grained personal access token": "Fein abgestuftes persönliches Zugriffstoken",
  "GITHUB_WEBHOOK_SECRET is not set on the server, so changes made on GitHub reach APM by hourly polling or “Sync now” rather than instantly.": "GITHUB_WEBHOOK_SECRET ist auf dem Server nicht gesetzt; Änderungen auf GitHub erreichen APM daher stündlich per Abfrage oder über „Jetzt synchronisieren“, nicht sofort.",
  "GitHub": "GitHub",
  "GitHub username": "GitHub-Benutzername",
  "GitHub → Settings → Developer settings → Fine-grained tokens. Limit it to this repository with permission Issues: Read and write (Metadata is included automatically). The token is verified now, stored encrypted, and never shown again.": "GitHub → Settings → Developer settings → Fine-grained tokens. Auf dieses Repository beschränken, Berechtigung Issues: Read and write (Metadata ist automatisch enthalten). Das Token wird jetzt geprüft, verschlüsselt gespeichert und nie wieder angezeigt.",
  "Import issues": "Issues importieren",
  "Import issues…": "Issues importieren…",
  "Importing…": "Importiere…",
  "Issue closed as completed →": "Issue als erledigt geschlossen →",
  "Issue closed as not planned →": "Issue als nicht geplant geschlossen →",
  "Issue reopened →": "Issue wieder geöffnet →",
  "Issues assigned to this GitHub user become tasks assigned to you when a project imports them.": "Issues, die diesem GitHub-Benutzer zugewiesen sind, werden beim Import zu Ihnen zugewiesenen Aufgaben.",
  "Labels": "Labels",
  "Mirror the task status as an apm:… label": "Aufgabenstatus als Label apm:… spiegeln",
  "Moving a task into this status closes the issue as “not planned”; any other done status closes it as “completed”.": "Wird eine Aufgabe in diesen Status verschoben, wird das Issue als „nicht geplant“ geschlossen; jeder andere Erledigt-Status schließt es als „erledigt“.",
  "No APM account has this GitHub username": "Kein APM-Konto hat diesen GitHub-Benutzernamen",
  "No issues match.": "Keine passenden Issues.",
  "Priority from labels": "Priorität aus Labels",
  "Replace the token or test the connection to resume.": "Token ersetzen oder Verbindung testen, um fortzufahren.",
  "Replace token": "Token ersetzen",
  "Repository": "Repository",
  "Status mapping": "Statuszuordnung",
  "Sync history": "Synchronisierungsverlauf",
  "Sync is paused:": "Synchronisierung pausiert:",
  "Sync now": "Jetzt synchronisieren",
  "Synced:": "Synchronisiert:",
  "Syncing…": "Synchronisiere…",
  "Test connection": "Verbindung testen",
  "Webhook: add": "Webhook: fügen Sie",
  "When an imported issue carries one of these labels, the task gets the matching priority (first match wins).": "Trägt ein importiertes Issue eines dieser Labels, erhält die Aufgabe die entsprechende Priorität (erster Treffer gewinnt).",
  "all": "alle",
  "already linked": "bereits verknüpft",
  "attempt": "Versuch",
  "checked": "geprüft",
  "closed": "geschlossen",
  "create": "anlegen",
  "errors": "Fehler",
  "failed": "fehlgeschlagen",
  "first done status": "erster Erledigt-Status",
  "first to-do status": "erster Offen-Status",
  "import issues as tasks, sync status": "Issues als Aufgaben importieren, Status synchronisieren",
  "label, e.g. bug": "Label, z. B. bug",
  "labels, comma-separated": "Labels, durch Kommas getrennt",
  "last checked": "zuletzt geprüft",
  "linked issues": "verknüpfte Issues",
  "next": "weiter",
  "not planned": "nicht geplant",
  "nothing to do": "nichts zu tun",
  "open": "offen",
  "open issues": "offene Issues",
  "page": "Seite",
  "previous": "zurück",
  "remove": "entfernen",
  "running": "läuft",
  "same as completed": "wie erledigt",
  "search title or #number": "Titel oder #Nummer suchen",
  "sent to GitHub": "an GitHub gesendet",
  "to the repository with the server's GITHUB_WEBHOOK_SECRET, content type JSON, events: Issues, Pushes, Pull requests. Without it, changes still arrive by hourly polling or “Sync now”.": "im Repository mit dem GITHUB_WEBHOOK_SECRET des Servers hinzu, Inhaltstyp JSON, Ereignisse: Issues, Pushes, Pull requests. Ohne ihn kommen Änderungen weiterhin stündlich per Abfrage oder über „Jetzt synchronisieren“ an.",
  "token": "Token",
  "update": "aktualisieren",
  "update pending": "Aktualisierung ausstehend",
  "updated here": "hier aktualisiert",
  "updates waiting": "Aktualisierungen warten",
  "Open menu": "Menü öffnen",
  "Close menu": "Menü schließen",
  "Main menu": "Hauptmenü",
  "Management": "Verwaltung",
}
